import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {SharedService} from '../../services/shared.service';
import {OrderModel} from '../../models/order.model';
import {OrderService} from '../../services/order.service';

@Component({
  selector: 'app-rate-dialog',
  templateUrl: './rate-dialog.component.html',
  styleUrls: ['./rate-dialog.component.scss']
})
export class RateDialogComponent implements OnInit {
  hoveredStar: number = 0;
  selectedStar: number = 0;
  stars: Array<number> = [1, 2, 3, 4, 5];
  title: string;
  message: string;
  messageText: string;
  text: string;
  order: OrderModel;
  showLoader: boolean;

  constructor(private dialogRef: MatDialogRef<RateDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private shared: SharedService,
              private orderService: OrderService) {
    this.title = data.title;
    this.message = data.message;
    this.messageText = data.messageText;
    this.text = data.rateText;
    this.order = data.order;
  }

  ngOnInit() {
  }

  hoverStar(starNumber: number) {
    let current = this.hoveredStar;
    if (starNumber == 0) {
      setTimeout(() => {
        if (current == this.hoveredStar) this.hoveredStar = 0;
      }, 100);
    } else {
      this.hoveredStar = starNumber;
    }
  }

  selectStar(starNumber: number) {
    this.selectedStar = starNumber;
  }

  starClass(starNumber: number) {
    if (this.selectedStar >= starNumber || this.hoveredStar > starNumber - 1) return 'mdi-star';
    if (this.hoveredStar < starNumber) return 'mdi-star-outline';
  }

  submitRating(starNumber: number) {
    this.showLoader = true;
    setTimeout(() => {
      this.orderService.updateOrder(this.order.id, {rating: starNumber})
        .then(_ => {
          this.showLoader = false;
          this.dialogRef.close();
        })
        .catch(err => {
          this.showLoader = false;
          this.dialogRef.close();
          this.shared.openErrorDialog({title: 'Error', body: 'Unexpected error, try again later'});
        });
    }, 1500);
  }


  laterRate() {
    this.shared.setRateLater(); //Set as rate later
    this.dialogRef.close();
  }

}
